// My Wins — list of wins logged by the current user with attestation status.

import { useQuery } from "@tanstack/react-query";
import { api, type Win } from "../lib/api";

const STATUS_COLOR: Record<Win["attestation_status"], string> = {
  pending:  "bg-amber-100 text-amber-900",
  verified: "bg-emerald-100 text-emerald-900",
  rejected: "bg-rose-100 text-rose-900",
};

export function MyWins() {
  const { data, isLoading } = useQuery<Win[]>({
    queryKey: ["wins", "mine"],
    queryFn: api.wins.mine,
  });

  if (isLoading) return <p>Loading…</p>;
  const wins = data ?? [];

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">My wins</h1>
      {wins.length === 0 ? (
        <p className="text-slate-600 text-sm">No wins logged yet. Submit a weekly intake with Q5=Yes.</p>
      ) : (
        <ul className="space-y-3">
          {wins.map((w) => (
            <li key={w.id} className="border rounded p-3 bg-white">
              <div className="flex items-baseline justify-between">
                <div className="text-sm text-slate-500">
                  {new Date(w.submitted_at).toLocaleDateString()} · {w.tier_used}
                  {w.high_impact ? " · high-impact" : null}
                </div>
                <span className={`text-xs px-2 py-0.5 rounded ${STATUS_COLOR[w.attestation_status]}`}>
                  {w.attestation_status}
                </span>
              </div>
              <p className="mt-1">{w.outcome}</p>
              <p className="text-sm text-slate-600 mt-1">
                {w.est_hours_saved}h saved · attesting: {w.manager_name}
              </p>
              {w.attestation_status === "verified" && w.verified_at ? (
                <p className="text-xs text-emerald-700 mt-1">
                  Verified {new Date(w.verified_at).toLocaleString()} (+50 XP)
                </p>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
